import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-charges',
  templateUrl: './charges.component.html',
  styleUrls: ['./charges.component.scss']
})
export class ChargesComponent implements OnInit {
// todo unused
  constructor() {
  }

  ngOnInit() {
  }

}
